import React from "react";
import { gbp, fmtDate } from "./bookingFormat";

const Stat = ({ label, value, testId, accent }) => (
  <div className="p-5 bg-white border border-stone-200/70 rounded-md">
    <div className="text-[11px] uppercase tracking-[0.16em] text-ink-muted">{label}</div>
    <div data-testid={testId} className={`mt-2 font-serif text-3xl ${accent || "text-ink"}`}>{value}</div>
  </div>
);

export const BookingTotals = ({ week }) => {
  const end = new Date(new Date(week.end).getTime() - 1).toISOString();
  return (
    <section data-testid="booking-totals" className="mt-8">
      <div className="text-sm text-ink-muted">
        This week · {fmtDate(week.start, false)} – {fmtDate(end, false)} (bookings made this week)
      </div>
      <div className="mt-3 grid grid-cols-2 md:grid-cols-4 lg:grid-cols-7 gap-3">
        <Stat label="Paid" value={week.paid} testId="totals-paid" accent="text-emerald-800" />
        <Stat label="Awaiting payment" value={week.pending} testId="totals-pending" accent="text-amber-800" />
        <Stat label="Released" value={week.released} testId="totals-released" />
        <Stat label="Cancelled" value={week.cancelled} testId="totals-cancelled" accent="text-red-700" />
        <Stat label="Taken" value={gbp(week.taken)} testId="totals-taken" />
        <Stat label="Refunded" value={gbp(week.refunded)} testId="totals-refunded" />
        <Stat label="Net" value={gbp(week.net)} testId="totals-net" accent="text-bronze-dark" />
      </div>
    </section>
  );
};
